import type {CSSObject} from "@emotion/react";
import styled from "@emotion/styled";

export const InsertsWrapper = styled.div<{isOneInsert?: boolean}>(({theme}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: theme?.breakpoints?.isMobile ? "column" : "row",
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "3/15",
  gridGap: theme?.breakpoints?.isMobile ? 16 : 20,
  justifyItems: "center",
  paddingBlock: theme?.breakpoints?.isMobile ? 20 : 30,
}));

export const InsertCardStyled = styled.div<{isOneInsert?: boolean}>(
  ({theme, isOneInsert}) => ({
    width: "100%",
    height: "100%",
    maxWidth: theme?.breakpoints?.isMobile
      ? "fit-content"
      : isOneInsert
        ? "600px"
        : "fit-content",
    minWidth: theme?.breakpoints?.isMobile ? "100%" : "33%",
    backgroundColor: theme?.colors?.primaryWhite,
    // padding: "26px 16px 20px 16px",
    boxShadow: "0px 0px 32px 0px #1D314014",
    borderRadius: 16,
  }),
);

export const ContentWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  paddingInline: 26,
  paddingBlock: "16px 22px",
});

export const Surtitle = styled.div(({theme}) => ({
  width: "100%",
  fontSize: "0.75rem",
  lineHeight: "1.5rem",
  fontWeight: 700,
  fontFamily: theme?.font?.manrope,
  textTransform: "uppercase",
}));

export const SurtitleEmojiWrapper = styled.div(
  (): CSSObject => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }),
);

export const FirstLineTitle = styled.div(({theme}) => ({
  fontSize: theme?.breakpoints?.isMobile ? "1.75rem" : "3rem",
  display: "inline",
  fontFamily: theme?.font?.manrope,
  textTransform: "uppercase",
  fontWeight: "bold",
  lineHeight: theme?.breakpoints?.isMobile ? 1.2 : 0.8,
  letterSpacing: "2%",
  color: theme?.colors?.brandBlue,
  marginRight: "8px",
  wordBreak: "break-word",
}));

export const SecondLineTitle = styled.div(({theme}) => ({
  fontSize: "0.75rem",
  fontFamily: theme?.font?.manrope,
  textTransform: "uppercase",
  fontWeight: "bold",
  lineHeight: theme?.breakpoints?.isMobile ? 1.9 : 1.1,
  letterSpacing: "2%",
  color: theme?.colors?.brandBlue,
  display: "inline",
  wordBreak: "break-word",
}));
